module.exports = "<div>\r\n    <div id=\"mainImage\">\r\n        <img src=\".\\assets\\img\\icons\\no-house-illustration.svg\">\r\n    </div>\r\n    <span class=\"mainMsg\">{{'You do not have any house connected to your account yet. Contact your house administrator or EDP:' | translate}}</span><br>\r\n  \r\n    <span class=\"number\"> <img style=\"margin-right: 15.7px;\"src=\"../../assets/img/icons/ic-phone.svg\">{{ customerServiceNumber | translate }}</span>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/no-house-user/no-house-user.component.html
// module id = ./src/app/shared/components/no-house-user/no-house-user.component.html
// module chunks = main